import { Images } from '@/assets/images';
import { PageTypeEnum } from '@/constant';
import { CloseCircleOutlined } from '@ant-design/icons';
import { memo } from 'react';

import { isNotNilOrEmpty } from 'ramda-adjunct';

import { BorderedLayout, Loading, RowItem, Tooltip } from '..';
import Button from '../common/button';
import Modal from '../common/modal';
import { useLogic } from './app-use-info-popup.logic';
import { IProps } from './app-use-info-popup.type';

const AppUseInfoPopup = (props: IProps) => {
	const { title = 'APP 사용 정보', refTableName, ...rest } = props;
	const {
		t,
		appUserInfo,
		fetchingGetAppUserInfo,

		onResetPassword,
		handleUnWithdrawn,

		tooltipVisible,
		setTooltipVisible,
	} = useLogic(props);

	return (
		<Modal title={title} {...rest}>
			{fetchingGetAppUserInfo ? (
				<Loading />
			) : (
				<>
					<div className="mb-2 flex items-center gap-5">
						<p className="text-[14px] font-bold">계정 정보</p>
					</div>
					<div className="grid grid-cols-2">
						<BorderedLayout containerClassName="border-r !border-l">
							<RowItem
								containerClassName="items-center"
								label="이메일(아이디)"
								required
							>
								<p className="text-xs text-font8">{appUserInfo?.email}</p>
							</RowItem>
							<RowItem
								label={
									<div className="flex items-center gap-[10px]">
										<p>비밀번호</p>
										<Tooltip
											title={
												<div className="flex items-start justify-between">
													<span>{t('warning-password')}</span>
													<CloseCircleOutlined
														className="ml-2 mt-1 cursor-pointer text-gray-400 hover:text-gray-600"
														onClick={(e) => {
															e.stopPropagation();
															setTooltipVisible(false);
														}}
													/>
												</div>
											}
											trigger="click"
											open={tooltipVisible}
											onOpenChange={setTooltipVisible}
										>
											<img
												src={Images.iconPasswordWarning}
												className="cursor-pointer"
											/>
										</Tooltip>
									</div>
								}
							>
								<Button
									secondary
									className="!min-w-[80px] font-normal text-[13px] h-[30px]"
									onClick={onResetPassword}
								>
									초기화
								</Button>
							</RowItem>
							<RowItem
								containerClassName="items-center"
								label="계정 요청"
								childrenClassName="justify-between"
							>
								{isNotNilOrEmpty(appUserInfo?.withdrawnDate) ? (
									<>
										<p className="text-xs text-font8">탈퇴 요청</p>
										<Button
											secondary
											className="!min-w-[80px] font-normal text-[13px] h-[30px]"
											onClick={handleUnWithdrawn}
										>
											탈퇴 취소
										</Button>
									</>
								) : (
									<p className="text-xs text-font8">-</p>
								)}
							</RowItem>
						</BorderedLayout>
						<BorderedLayout>
							<RowItem containerClassName="items-center" label="계정 등록일">
								<p className="text-xs text-font8">{appUserInfo?.registDt}</p>
							</RowItem>
							<RowItem containerClassName="items-center" label="최근 접속일">
								<p className="text-xs text-font8">
									{appUserInfo?.lastestLoggedInDt}
								</p>
							</RowItem>
							<RowItem containerClassName="items-center" label="약관 동의일">
								<p className="text-xs text-font8">{appUserInfo?.agreementDt}</p>
							</RowItem>
						</BorderedLayout>
					</div>

					<div className="my-2 flex items-center gap-5">
						<p className="text-[14px] font-bold">PUSH 알림 설정 정보</p>
					</div>

					<div className="grid grid-cols-2">
						<BorderedLayout containerClassName="border-r !border-l">
							<RowItem containerClassName="items-center" label="공지사항">
								<p className="text-xs text-font8">
									{appUserInfo?.notiRegistDt}
								</p>
							</RowItem>
						</BorderedLayout>

						{refTableName === PageTypeEnum.FRANCHISE && (
							<BorderedLayout>
								<RowItem
									containerClassName="items-center"
									label="근로자 출국 예정일"
								>
									<p className="text-xs text-font8">
										{appUserInfo?.expApplicantNotiRegistDt}
									</p>
								</RowItem>
							</BorderedLayout>
						)}
					</div>
				</>
			)}
		</Modal>
	);
};

export default memo(AppUseInfoPopup);
